import React from 'react';
import './Logo.css';

interface LogoProps {
  imagePath: string;
  width?: number | string;
  height?: number | string;
  maxWidth?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  imagePath, 
  width = '150', 
  height = 'auto',
  maxWidth = '100%',
  className = '' 
}) => {
  return (
    <img 
      src={imagePath} 
      alt="Logo" 
      width={width} 
      height={height} 
      className={className}
      style={{ maxWidth: maxWidth }}
    />
  );
};

export default Logo;